import { DSNCVideoSlider, DSTinyUniItem } from 'shared-definitions/types'
import { youtubeVideoId } from 'shared-code/string'
import { ApiComponentVideoSlider, ApiYoutubeVideo } from 'data-source/types.wp'
import { pLinkExternalMapper } from './pLinkMapper'

export function ncVideoSlider(input: ApiComponentVideoSlider): DSNCVideoSlider | [] {
  const items = input.items.flatMap(youtubeLinkMapper)
  if (items.length) {
    return {
      resource: 'nc-video-slider',
      items,
    }
  }
  return []
}

function youtubeLinkMapper(input: ApiYoutubeVideo): DSTinyUniItem | DSTinyUniItem[] {
  const youtubeId = youtubeVideoId(input.url)
  if (!youtubeId) {
    return []
  }
  return {
    title: input.title,
    image: {
      src: `https://img.youtube.com/vi/${youtubeId}/mqdefault.jpg`,
      title: null,
      alt: null,
      srcSet: null,
      caption: null,
      credits: [],
      size: null,
      webpSrcSet: null,
    },
    pLink: pLinkExternalMapper(input.url),
  }
}
